
const categories = [
    {
        "categoryId": 1,
        name: "دیجیتال و الکترونیکی",
        subCategories: [
            {
                subCategoryId: 1,
                name: "لپتاپ و تبلت"
            },
            {
                subCategoryId: 2,
                name: "اسپیکر بلوتوثی"
            },
            {
                subCategoryId: 3,
                name: "ویدئو پروژکتور "
            },
            {
                subCategoryId: 4,
                name: "پرینتر "
            },
            {
                subCategoryId: 5,
                name: " اسکنر"
            },
            {
                subCategoryId: 6,
                name: "تبلت"
            },
            {
                subCategoryId: 7,
                name: "لپ تاپ"
            },
            {
                subCategoryId: 8,
                name: "تجهیزات عکاسی و فیلمبرداری",
                subSubCategories: [
                    {
                        subCategoryId: 9,
                        name: "دوربین عکاسی DSLR"
                    },
                    {
                        subCategoryId: 10,
                        name: "دوربین بدون آینه (Mirrorless)"
                    },
                    {
                        subCategoryId: 11,
                        name: "دوربین فیلمبرداری"
                    },
                    {
                        subCategoryId: 12,
                        name: "دوربین ورزشی (اکشن کمرا)"
                    },
                    {
                        subCategoryId: 13,
                        name: "دوربین ۳۶۰ درجه"
                    },
                    {
                        subCategoryId: 14,
                        name: "پایه دوربین "
                    },
                    {
                        subCategoryId: 15,
                        name: "لنز دوربین"
                    },
                    {
                        subCategoryId: 16,
                        name: "فلاش اکسترنال"
                    },
                    {
                        subCategoryId: 17,
                        name: "نور ثابت و رینگ لایت"
                    },
                    {
                        subCategoryId: 18,
                        name: "باتری و شارژر دوربین"
                    },
                    {
                        subCategoryId: 19,
                        name: "کارت حافظه "
                    },
                    {
                        subCategoryId: 20,
                        name: "کوله و کیف دوربین"
                    },
                    {
                        subCategoryId: 21,
                        name: "پرده کروماکی"
                    },
                    {
                        subCategoryId: 22,
                        name: "اسلایدر و استابلایزر"
                    },
                    {
                        subCategoryId: 23,
                        name: "رکوردر صدا و تصویر"
                    },
                    {
                        subCategoryId: 24,
                        name: "هولدر موبایل برای فیلمبرداری"
                    },
                    {
                        subCategoryId: 25,
                        name: "پهپاد فیلمبرداری (Drone)"
                    },
                    {
                        subCategoryId: 26,
                        name: " LED پنل"
                    },
                    {
                        subCategoryId: 27,
                        name: "سافت باکس"
                    },
                    {
                        subCategoryId: 28,
                        name: "فیلتر لنز"
                    }
                ]
            },
            {
                subCategoryId: 29,
                name: "تجهیزات صوت و تصویر",
                subSubCategories: [
                    {
                        subCategoryId: 30,
                        name: "میکروفون یقه ای"
                    },
                    {
                        subCategoryId: 31,
                        name: "میکروفون استودیویی"
                    },
                    {
                        subCategoryId: 32,
                        name: "میکروفون بی سیم"
                    },
                    {
                        subCategoryId: 33,
                        name: "اسپیکر بلوتوثی"
                    },
                    {
                        subCategoryId: 34,
                        name: "اسپیکر حرفه ای و مانیتورینگ"
                    },
                    {
                        subCategoryId: 35,
                        name: "هدفون استودیویی"
                    },
                    {
                        subCategoryId: 36,
                        name: "میکسر صدا"
                    },
                    {
                        subCategoryId: 37,
                        name: "آمپلی فایر"
                    },
                    {
                        subCategoryId: 38,
                        name: "سیستم های کنفرانس صوتی"
                    },
                    {
                        subCategoryId: 39,
                        name: "ویدئو پروژکتور"
                    },
                    {
                        subCategoryId: 40,
                        name: "پرده نمایش"
                    },
                    {
                        subCategoryId: 41,
                        name: "نمایشگر و تلویزیون حرفه ای"
                    },
                    {
                        subCategoryId: 42,
                        name: "ساندبار"
                    },
                    {
                        subCategoryId: 43,
                        name: "کارت صدا"
                    },
                    {
                        subCategoryId: 44,
                        name: "رکوردر صوتی"
                    },
                    {
                        subCategoryId: 45,
                        name: "اکولایزر"
                    },
                    {
                        subCategoryId: 46,
                        name: "دستگاه ترجمه همزمان"
                    },
                    {
                        subCategoryId: 47,
                        name: "تجهیزات آکوستیک و عایق صدا"
                    },
                    {
                        subCategoryId: 48,
                        name: "دستگاههای استریمینگ"
                    },
                    {
                        subCategoryId: 49,
                        name: "چراغ های LED"
                    },
                    {
                        subCategoryId: 50,
                        name: "نورافکن"
                    },
                    {
                        subCategoryId: 51,
                        name: "سیستم های نورپردازی هوشمند"
                    },
                    {
                        subCategoryId: 52,
                        name: "کابل های صوتی و تصویری"
                    }
                ]
            },
            {
                subCategoryId: 53,
                name: "تجهیزات گیمینگ (بازی)",
                subSubCategories: [
                    {
                        subCategoryId: 54,
                        name: "کنسول بازی "
                    },
                    {
                        subCategoryId: 55,
                        name: "کنترلر و دسته بازی"
                    },
                    {
                        subCategoryId: 56,
                        name: "کیبورد و ماوس گیمینگ"
                    },
                    {
                        subCategoryId: 57,
                        name: "مانیتور گیمینگ"
                    },
                    {
                        subCategoryId: 58,
                        name: "هدست گیمینگ"
                    },
                    {
                        subCategoryId: 59,
                        name: "صندلی گیمینگ"
                    },
                    {
                        subCategoryId: 60,
                        name: "دسته بازی موبایل"
                    },
                    {
                        subCategoryId: 61,
                        name: "استند و داک کنسول"
                    },
                    {
                        subCategoryId: 62,
                        name: "خنک کننده کنسول"
                    },
                    {
                        subCategoryId: 63,
                        name: "کارت گرافیک گیمینگ"
                    },
                    {
                        subCategoryId: 64,
                        name: "پردازنده مخصوص بازی"
                    },
                    {
                        subCategoryId: 65,
                        name: "میز گیمینگ"
                    },
                    {
                        subCategoryId: 66,
                        name: "نورپردازی RGB"
                    },
                    {
                        subCategoryId: 67,
                        name: "واقعیت مجازی (VR) مخصوص بازی"
                    },
                    {
                        subCategoryId: 68,
                        name: "فرمان و پدال شبیه ساز رانندگی"
                    },
                    {
                        subCategoryId: 69,
                        name: "کارت کپچر و استریم"
                    },
                    {
                        subCategoryId: 70,
                        name: "میکروفون مخصوص استریم"
                    },
                    {
                        subCategoryId: 71,
                        name: "سنسورهای حرکتی"
                    }
                ]
            }
        ]
    },
    {
        categoryId: 2,
        name: "ورزشی و تفریحی",
        subCategories: [
            {
                subCategoryId: 72,
                name: "تجهیزات ورزشی",
                subSubCategories: [
                    {
                        subCategoryId: 73,
                        name: "تجهیزات بدنسازی"
                    },
                    {
                        subCategoryId: 74,
                        name: "طناب ورزشی"
                    },
                    {
                        subCategoryId: 75,
                        name: "دوچرخه"
                    },
                    {
                        subCategoryId: 76,
                        name: "ترامپولین"
                    },
                    {
                        subCategoryId: 77,
                        name: "میز و راکت پینگ پنگ  "
                    },
                    {
                        subCategoryId: 78,
                        name: "تجهیزات کوهنوردی"
                    },
                    {
                        subCategoryId: 79,
                        name: "انواع توپ ورزشی "
                    },
                    {
                        subCategoryId: 80,
                        name: "لباس و کفش ورزشی"
                    },
                    {
                        subCategoryId: 81,
                        name: "اسکیت و اسکوتر"
                    },
                    {
                        subCategoryId: 82,
                        name: "میز فوتبال دستی"
                    },
                    {
                        subCategoryId: 83,
                        name: "لباس و تجهیزات موتور سواری"
                    },
                    {
                        subCategoryId: 84,
                        name: "کیسه بوکس"
                    },
                    {
                        subCategoryId: 85,
                        name: " لباس و تجهیزات غواصی"
                    },
                    {
                        subCategoryId: 86,
                        name: "تخته موج سواری"
                    },
                    {
                        subCategoryId: 87,
                        name: "تجهیزات ماهیگیری"
                    },
                    {
                        subCategoryId: 88,
                        name: "لباس و تجهیزات اسکی"
                    },
                    {
                        subCategoryId: 89,
                        name: "تخته اسنوبورد"
                    },
                    {
                        subCategoryId: 90,
                        name: "تجهیزات شنا"
                    },
                    {
                        subCategoryId: 91,
                        name: "چتر نجات"
                    },
                    {
                        subCategoryId: 92,
                        name: "تجهیزات تیراندازی "
                    }
                ]
            },
            {
                subCategoryId: 93,
                name: "سفر و کمپینگ",
                subSubCategories: [
                    {
                        subCategoryId: 94,
                        name: "چادر مسافرتی"
                    },
                    {
                        subCategoryId: 95,
                        name: "کیسه خواب"
                    },
                    {
                        subCategoryId: 96,
                        name: "زیرانداز"
                    },
                    {
                        subCategoryId: 97,
                        name: "کوله پشتی کوهنوردی"
                    },
                    {
                        subCategoryId: 98,
                        name: "چراغ قوه و هدلایت"
                    },
                    {
                        subCategoryId: 99,
                        name: "اجاق سفری"
                    },
                    {
                        subCategoryId: 100,
                        name: "منقل و باربیکیو"
                    },
                    {
                        subCategoryId: 101,
                        name: "قمقمه و فلاسک"
                    },
                    {
                        subCategoryId: 102,
                        name: "ظرف و ظروف سفری"
                    },
                    {
                        subCategoryId: 103,
                        name: "چاقو و ابزار چندکاره"
                    },
                    {
                        subCategoryId: 104,
                        name: "صندلی و میز تاشو"
                    },
                    {
                        subCategoryId: 105,
                        name: "پتوی مسافرتی"
                    },
                    {
                        subCategoryId: 106,
                        name: "پاوربانک خورشیدی"
                    },
                    {
                        subCategoryId: 107,
                        name: "گاز سفری"
                    },
                    {
                        subCategoryId: 108,
                        name: "کلمن آب"
                    },
                    {
                        subCategoryId: 109,
                        name: "دوش سفری"
                    },
                    {
                        subCategoryId: 110,
                        name: "قطب نما"
                    },
                    {
                        subCategoryId: 111,
                        name: "عینک آفتابی"
                    },
                    {
                        subCategoryId: 112,
                        name: "کلاه آفتاب گیر"
                    },
                    {
                        subCategoryId: 113,
                        name: "کرم ضدآفتاب"
                    },
                    {
                        subCategoryId: 114,
                        name: "دوربین دوچشمی"
                    },
                    {
                        subCategoryId: 115,
                        name: "دستگاه تصفیه آب سفری"
                    },
                    {
                        subCategoryId: 116,
                        name: "طناب و کارابین"
                    },
                    {
                        subCategoryId: 117,
                        name: "اسپری ضدحشرات"
                    },
                    {
                        subCategoryId: 118,
                        name: "واکی تاکی"
                    },
                    {
                        subCategoryId: 119,
                        name: "نردبان کوهنوردی"
                    },
                    {
                        subCategoryId: 120,
                        name: "کفش کوهنوردی"
                    },
                    {
                        subCategoryId: 121,
                        name: "لباس مخصوص طبیعت گردی"
                    },
                    {
                        subCategoryId: 122,
                        name: "باتوم کوهنوردی"
                    },
                    {
                        subCategoryId: 123,
                        name: "کیت کمک های اولیه"
                    },
                    {
                        subCategoryId: 124,
                        name: "دستکش مخصوص کمپینگ"
                    },
                    {
                        subCategoryId: 125,
                        name: "سایبان"
                    },
                    {
                        subCategoryId: 126,
                        name: "دوربین دوچشمی"
                    },
                    {
                        subCategoryId: 127,
                        name: "قطب نما و GPS"
                    }
                ]
            }
        ]
    },
    {
        "categoryId": 3,
        name: "ابزارآلات",
        subCategories: [
            {
                subCategoryId: 128,
                name: "ابزارآلات عمومی و خانگی",
                subSubCategories: [
                    {
                        subCategoryId: 129,
                        name: "دریل "
                    },
                    {
                        subCategoryId: 130,
                        name: "پیچ گوشتی شارژی"
                    },
                    {
                        subCategoryId: 131,
                        name: "ابزارآلات سبک (انواع آچار و پیچ گوشتی)"
                    },
                    {
                        subCategoryId: 132,
                        name: "تراز دستی"
                    },
                    {
                        subCategoryId: 133,
                        name: "چسب حرارتی"
                    },
                    {
                        subCategoryId: 134,
                        name: "سشوار صنعتی"
                    },
                    {
                        subCategoryId: 135,
                        name: "اره عمودبر"
                    },
                    {
                        subCategoryId: 136,
                        name: "پیچ گوشتی ستاره ای"
                    },
                    {
                        subCategoryId: 137,
                        name: "ابزارآلات ساختمانی"
                    },
                    {
                        subCategoryId: 138,
                        name: "بالابر ساختمانی"
                    },
                    {
                        subCategoryId: 139,
                        name: "مته بتن کن"
                    },
                    {
                        subCategoryId: 140,
                        name: "تراز"
                    },
                    {
                        subCategoryId: 141,
                        name: "دژبر"
                    },
                    {
                        subCategoryId: 142,
                        name: "تخته داربست"
                    },
                    {
                        subCategoryId: 143,
                        name: "کمپرسور بادی"
                    },
                    {
                        subCategoryId: 144,
                        name: "میکسر بتن"
                    },
                    {
                        subCategoryId: 145,
                        name: "دستگاه برش سنگ و سرامیک"
                    },
                    {
                        subCategoryId: 146,
                        name: "چکش تخریب"
                    },
                    {
                        subCategoryId: 147,
                        name: "دستگاه جوش"
                    },
                    {
                        subCategoryId: 148,
                        name: "دستگاه شیارزن"
                    },
                    {
                        subCategoryId: 149,
                        name: "قیچی میلگردبر"
                    },
                    {
                        subCategoryId: 150,
                        name: "قالب بندی بتن"
                    },
                    {
                        subCategoryId: 151,
                        name: "ابزار دیوار چینی (ماله، کمچه، شاقول و...)"
                    }
                ]
            },
            {
                subCategoryId: 152,
                name: "ابزارآلات صنعتی",
                subSubCategories: [
                    {
                        subCategoryId: 153,
                        name: "دریل صنعتی"
                    },
                    {
                        subCategoryId: 154,
                        name: "فرز سنگ بری"
                    },
                    {
                        subCategoryId: 155,
                        name: "مینی فرز"
                    },
                    {
                        subCategoryId: 156,
                        name: "کمپرسور باد"
                    },
                    {
                        subCategoryId: 157,
                        name: "دستگاه تراش"
                    },
                    {
                        subCategoryId: 158,
                        name: "سنگ رومیزی"
                    },
                    {
                        subCategoryId: 159,
                        name: "پرس هیدرولیک"
                    },
                    {
                        subCategoryId: 160,
                        name: "اینورتر جوشکاری"
                    },
                    {
                        subCategoryId: 161,
                        name: "اره نواری"
                    },
                    {
                        subCategoryId: 162,
                        name: "ابزارهای بادی و پنوماتیک"
                    },
                    {
                        subCategoryId: 163,
                        name: "دستگاه CNC"
                    },
                    {
                        subCategoryId: 164,
                        name: "دستگاه حکاکی و برش لیزر"
                    },
                    {
                        subCategoryId: 165,
                        name: "قیچی برش صنعتی"
                    },
                    {
                        subCategoryId: 166,
                        name: "لیفتراک"
                    },
                    {
                        subCategoryId: 167,
                        name: "جک پالت"
                    },
                    {
                        subCategoryId: 168,
                        name: "جرثقیل دستی"
                    },
                    {
                        subCategoryId: 169,
                        name: "گیج فشار"
                    },
                    {
                        subCategoryId: 170,
                        name: "دماسنج صنعتی"
                    }
                ]
            },
            {
                subCategoryId: 171,
                name: "ابزارآلات مکانیکی و خودرویی",
                subSubCategories: [
                    {
                        subCategoryId: 172,
                        name: "جک خودرو"
                    },
                    {
                        subCategoryId: 173,
                        name: "آچار بکس"
                    },
                    {
                        subCategoryId: 174,
                        name: "کمپرسور باد"
                    },
                    {
                        subCategoryId: 175,
                        name: "ساکشن روغن"
                    },
                    {
                        subCategoryId: 176,
                        name: "انژکتور شور"
                    },
                    {
                        subCategoryId: 177,
                        name: "مولتی متر خودرو"
                    },
                    {
                        subCategoryId: 178,
                        name: "لوازم پنچرگیری"
                    },
                    {
                        subCategoryId: 179,
                        name: "پولی کش"
                    },
                    {
                        subCategoryId: 180,
                        name: "دستگاه دیاگ"
                    },
                    {
                        subCategoryId: 181,
                        name: "سشوار صنعتی"
                    },
                    {
                        subCategoryId: 182,
                        name: "ترکمتر"
                    }
                ]
            },
            {
                subCategoryId: 183,
                name: "ابزارآلات اندازه گیری و سنجش",
                subSubCategories: [
                    {
                        subCategoryId: 184,
                        name: "متر لیزری"
                    },
                    {
                        subCategoryId: 185,
                        name: "تراز دیجیتالی"
                    },
                    {
                        subCategoryId: 186,
                        name: "کولیس دیجیتال"
                    },
                    {
                        subCategoryId: 187,
                        name: "میکرومتر"
                    },
                    {
                        subCategoryId: 188,
                        name: "مولتی متر"
                    },
                    {
                        subCategoryId: 189,
                        name: "دوربین نقشه برداری"
                    },
                    {
                        subCategoryId: 190,
                        name: "ترمومتر"
                    },
                    {
                        subCategoryId: 191,
                        name: "ضخامت سنج"
                    },
                    {
                        subCategoryId: 192,
                        name: "رطوبت سنج"
                    },
                    {
                        subCategoryId: 193,
                        name: "سرعت سنج باد"
                    },
                    {
                        subCategoryId: 194,
                        name: "دیتالاگر دما"
                    },
                    {
                        subCategoryId: 195,
                        name: "فشارسنج دیجیتال"
                    },
                    {
                        subCategoryId: 196,
                        name: "ساعت اندیکاتور"
                    }
                ]
            },
            {
                subCategoryId: 197,
                name: "ابزار و تجهیزات کارگاهی",
                subSubCategories: [
                    {
                        subCategoryId: 198,
                        name: "دستگاه CNC"
                    },
                    {
                        subCategoryId: 199,
                        name: "اره فلکه ای"
                    },
                    {
                        subCategoryId: 200,
                        name: "دستگاه جوش"
                    },
                    {
                        subCategoryId: 201,
                        name: "سنگ فرز"
                    },
                    {
                        subCategoryId: 202,
                        name: "دستگاه تراش"
                    },
                    {
                        subCategoryId: 203,
                        name: "گیره نجاری"
                    },
                    {
                        subCategoryId: 204,
                        name: "دستگاه مکنده صنعتی"
                    },
                    {
                        subCategoryId: 205,
                        name: "دستگاه فرز نجاری"
                    },
                    {
                        subCategoryId: 206,
                        name: "کمپرسور باد صنعتی"
                    },
                    {
                        subCategoryId: 207,
                        name: "اسپری رنگ"
                    },
                    {
                        subCategoryId: 208,
                        name: "دستگاه پولیش"
                    },
                    {
                        subCategoryId: 209,
                        name: "سوهان"
                    },
                    {
                        subCategoryId: 210,
                        name: "پیستوله رنگ"
                    }
                ]
            },
            {
                subCategoryId: 211,
                name: "ابزارآلات تاسیساتی",
                subSubCategories: [
                    {
                        subCategoryId: 212,
                        name: "لوله بر"
                    },
                    {
                        subCategoryId: 213,
                        name: "دستگاه جوش لوله"
                    },
                    {
                        subCategoryId: 214,
                        name: "تفنگ میخکوب"
                    },
                    {
                        subCategoryId: 215,
                        name: "لوله خم کن"
                    },
                    {
                        subCategoryId: 216,
                        name: "فنر لوله بازکن"
                    },
                    {
                        subCategoryId: 217,
                        name: "فشارسنج لوله"
                    },
                    {
                        subCategoryId: 218,
                        name: "آچار لوله گیر"
                    },
                    {
                        subCategoryId: 219,
                        name: "دریل ستونی"
                    },
                    {
                        subCategoryId: 220,
                        name: "دستگاه تست نشتی گاز"
                    },
                    {
                        subCategoryId: 221,
                        name: "دستگاه برش لوله"
                    },
                    {
                        subCategoryId: 222,
                        name: "عایق بندی حرارتی"
                    }
                ]
            },
            {
                subCategoryId: 223,
                name: "تجهیزات ایمنی",
                subSubCategories: [
                    {
                        subCategoryId: 224,
                        name: "کلاه ایمنی "
                    },
                    {
                        subCategoryId: 225,
                        name: "کفش ایمنی"
                    },
                    {
                        subCategoryId: 226,
                        name: "عینک محافظ"
                    },
                    {
                        subCategoryId: 227,
                        name: "شیلد صورت"
                    },
                    {
                        subCategoryId: 228,
                        name: "گوش گیر الکترونیکی"
                    },
                    {
                        subCategoryId: 229,
                        name: "دستکش ایمنی"
                    },
                    {
                        subCategoryId: 230,
                        name: "لباس ایمنی"
                    },
                    {
                        subCategoryId: 231,
                        name: "کپسول آتش نشانی"
                    }
                ]
            },
            {
                subCategoryId: 232,
                name: "ابزارآلات باغبانی و کشاورزی",
                subSubCategories: [
                    {
                        subCategoryId: 233,
                        name: "بیل، کلنگ، شن کش، داس"
                    },
                    {
                        subCategoryId: 234,
                        name: "قیچی و اره باغبانی"
                    },
                    {
                        subCategoryId: 235,
                        name: "چمن زن "
                    },
                    {
                        subCategoryId: 236,
                        name: "سمپاش"
                    },
                    {
                        subCategoryId: 237,
                        name: "نهرکن"
                    },
                    {
                        subCategoryId: 238,
                        name: "دستگاه علف تراش"
                    },
                    {
                        subCategoryId: 239,
                        name: "نازل آبیاری"
                    },
                    {
                        subCategoryId: 240,
                        name: "موتور پمپ آب"
                    },
                    {
                        subCategoryId: 241,
                        name: "بذرپاش"
                    },
                    {
                        subCategoryId: 242,
                        name: "کودپاش"
                    },
                    {
                        subCategoryId: 243,
                        name: "دستگاه وجین کن"
                    },
                    {
                        subCategoryId: 244,
                        name: "تراکتور کوچک"
                    },
                    {
                        subCategoryId: 245,
                        name: "فرغون"
                    }
                ]
            }
        ]
    },
    {
        "categoryId": 4,
        name: "مراسم و رویدادها",
        subCategories: [
            {
                subCategoryId: 246,
                name: "تجهیزات  نورپردازی",
                subSubCategories: [
                    {
                        subCategoryId: 247,
                        name: "رقص نور"
                    },
                    {
                        subCategoryId: 248,
                        name: "مه ساز"
                    },
                    {
                        subCategoryId: 249,
                        name: "استروب"
                    },
                    {
                        subCategoryId: 250,
                        name: "لیزرشو"
                    },
                    {
                        subCategoryId: 251,
                        name: "افکت های نورپردازی"
                    }
                ]
            },
            {
                subCategoryId: 252,
                name: "تجهیزات پذیرایی و سرو غذا",
                subSubCategories: [
                    {
                        subCategoryId: 253,
                        name: "ظروف کرایه ای"
                    },
                    {
                        subCategoryId: 254,
                        name: "میز و صندلی "
                    },
                    {
                        subCategoryId: 255,
                        name: "ترموس چای و قهوه"
                    },
                    {
                        subCategoryId: 256,
                        name: "سماور"
                    },
                    {
                        subCategoryId: 257,
                        name: "میز بار"
                    },
                    {
                        subCategoryId: 258,
                        name: "سینی پذیرایی"
                    },
                    {
                        subCategoryId: 259,
                        name: "دستگاه یخ ساز"
                    }
                ]
            },
            {
                subCategoryId: 260,
                name: "لوازم دکور و تزئینات",
                subSubCategories: [
                    {
                        subCategoryId: 261,
                        name: "استند گل "
                    },
                    {
                        subCategoryId: 262,
                        name: "فرش و موکت"
                    },
                    {
                        subCategoryId: 263,
                        name: "بنر و استند تبلیغاتی"
                    },
                    {
                        subCategoryId: 264,
                        name: "میز کادو"
                    },
                    {
                        subCategoryId: 265,
                        name: "پرده پس زمینه"
                    },
                    {
                        subCategoryId: 266,
                        name: "قاب عکس تشریفاتی"
                    }
                ]
            },
            {
                subCategoryId: 267,
                name: "سازه های مراسم و نمایشگاه ها",
                subSubCategories: [
                    {
                        subCategoryId: 268,
                        name: "استیج"
                    },
                    {
                        subCategoryId: 269,
                        name: "سکو"
                    },
                    {
                        subCategoryId: 270,
                        name: "چادر و سایه بان مراسم"
                    },
                    {
                        subCategoryId: 271,
                        name: "داربست نمایشگاهی"
                    },
                    {
                        subCategoryId: 272,
                        name: "بنر و بک دراپ تبلیغاتی"
                    }
                ]
            },
            {
                subCategoryId: 273,
                name: "لوازم آتش بازی و نمایش ویژه",
                subSubCategories: [
                    {
                        subCategoryId: 274,
                        name: "دستگاه مه سرد"
                    },
                    {
                        subCategoryId: 275,
                        name: "کاغذپاش"
                    },
                    {
                        subCategoryId: 276,
                        name: "گاز هلیوم برای بادکنک"
                    }
                ]
            },
            {
                subCategoryId: 277,
                name: "سیستم های مدیریت رویداد و ثبت نام",
                subSubCategories: [
                    {
                        subCategoryId: 278,
                        name: "بلیت خوان "
                    },
                    {
                        subCategoryId: 279,
                        name: "دستگاه نوبت دهی"
                    },
                    {
                        subCategoryId: 280,
                        name: "نرم افزار مدیریت مهمانان"
                    },
                    {
                        subCategoryId: 281,
                        name: "QR کدخوان"
                    }
                ]
            },
            {
                subCategoryId: 282,
                name: "تجهیزات گرمایشی و سرمایشی",
                subSubCategories: [
                    {
                        subCategoryId: 283,
                        name: "بخاری فضای باز"
                    },
                    {
                        subCategoryId: 284,
                        name: "هیتر گازی"
                    },
                    {
                        subCategoryId: 285,
                        name: "کولر پرتابل"
                    },
                    {
                        subCategoryId: 286,
                        name: "پنکه صنعتی"
                    },
                    {
                        subCategoryId: 287,
                        name: "بخارساز فضاهای باز"
                    }
                ]
            },
            {
                subCategoryId: 288,
                name: "تجهیزات برگزاری کنفرانس و سمینار",
                subSubCategories: [
                    {
                        subCategoryId: 289,
                        name: "ویدئو پروژکتور"
                    },
                    {
                        subCategoryId: 290,
                        name: "پرده نمایش"
                    },
                    {
                        subCategoryId: 291,
                        name: "تریبون سخنرانی"
                    },
                    {
                        subCategoryId: 292,
                        name: "سیستم ترجمه همزمان"
                    }
                ]
            }
        ]
    },
    {
        "categoryId": 5,
        name: "فرهنگی، هنری و آموزشی",
        subCategories: [
            {
                subCategoryId: 293,
                name: "کتاب‌های تخصصی"
            },
            {
                subCategoryId: 294,
                name: "کتاب‌های ادبی، داستان، رمان و شعر"
            },
            {
                subCategoryId: 295,
                name: "کتاب‌های کمک درسی"
            },
            {
                subCategoryId: 296,
                name: "ماکت‌ها و مدل‌های آموزشی"
            },
            {
                subCategoryId: 297,
                name: "لوازم موسیقی و سازها",
                subSubCategories: [
                    {
                        subCategoryId: 298,
                        name: "گیتار"
                    },
                    {
                        subCategoryId: 299,
                        name: "ویولن"
                    },
                    {
                        subCategoryId: 300,
                        name: "پیانو"
                    },
                    {
                        subCategoryId: 301,
                        name: "کیبورد"
                    },
                    {
                        subCategoryId: 302,
                        name: "سنتور"
                    },
                    {
                        subCategoryId: 303,
                        name: "دف"
                    },
                    {
                        subCategoryId: 304,
                        name: "تار"
                    },
                    {
                        subCategoryId: 305,
                        name: "سه تار"
                    },
                    {
                        subCategoryId: 306,
                        name: "تنبک"
                    },
                    {
                        subCategoryId: 307,
                        name: "کاخن"
                    },
                    {
                        subCategoryId: 308,
                        name: "سازدهنی "
                    },
                    {
                        subCategoryId: 309,
                        name: "مترونوم"
                    },
                    {
                        subCategoryId: 310,
                        name: "تیونر"
                    },
                    {
                        subCategoryId: 311,
                        name: "مضراب "
                    },
                    {
                        subCategoryId: 312,
                        name: "استند نت "
                    }
                ]
            },
            {
                subCategoryId: 313,
                name: "لوازم صنایع دستی و هنرهای سنتی ",
                subSubCategories: [
                    {
                        subCategoryId: 314,
                        name: "ابزار چرم دوزی "
                    },
                    {
                        subCategoryId: 315,
                        name: "دستگاه گلدوزی"
                    },
                    {
                        subCategoryId: 316,
                        name: "ابزار سفال گری "
                    },
                    {
                        subCategoryId: 317,
                        name: "وسایل معرق کاری"
                    },
                    {
                        subCategoryId: 318,
                        name: "خطاطی و خوشنویسی"
                    },
                    {
                        subCategoryId: 319,
                        name: "ابزار حکاکی روی چوب و فلز"
                    }
                ]
            }
        ]
    },
    {
        "categoryId": 6,
        name: "مد، پوشاک و زیبایی",
        subCategories: [
            {
                subCategoryId: 320,
                name: "مد و پوشاک",
                subSubCategories: [
                    {
                        subCategoryId: 321,
                        name: "لباس های مجلسی زنانه"
                    },
                    {
                        subCategoryId: 322,
                        name: "لباس عروس"
                    },
                    {
                        subCategoryId: 323,
                        name: "کت و شلوار مجلسی"
                    },
                    {
                        subCategoryId: 324,
                        name: "لباس های سنتی"
                    },
                    {
                        subCategoryId: 325,
                        name: "لباس نمایش و تئاتر"
                    },
                    {
                        subCategoryId: 326,
                        name: "جواهرات و زیورآلات لوکس"
                    },
                    {
                        subCategoryId: 327,
                        name: "ساعت های لوکس"
                    },
                    {
                        subCategoryId: 328,
                        name: "عینک آفتابی برند"
                    },
                    {
                        subCategoryId: 329,
                        name: "لباس های فصلی خاص"
                    },
                    {
                        subCategoryId: 330,
                        name: "لباس های تم دار و خاص"
                    },
                    {
                        subCategoryId: 331,
                        name: "اکسسوری ها و لوازم جانبی"
                    }
                ]
            },
            {
                subCategoryId: 332,
                name: "کودکان و نوزادان",
                subSubCategories: [
                    {
                        subCategoryId: 333,
                        name: "کالسکه"
                    },
                    {
                        subCategoryId: 334,
                        name: "کریر"
                    },
                    {
                        subCategoryId: 335,
                        name: "صندلی ماشین کودک"
                    },
                    {
                        subCategoryId: 336,
                        name: "تاب و سرسره"
                    },
                    {
                        subCategoryId: 337,
                        name: "تخت و گهواره"
                    },
                    {
                        subCategoryId: 338,
                        name: "واکر کودک"
                    },
                    {
                        subCategoryId: 339,
                        name: "لباس های مناسب جشن و عکاسی کودک"
                    },
                    {
                        subCategoryId: 340,
                        name: "لباس شخصیت های کارتونی"
                    },
                    {
                        subCategoryId: 341,
                        name: "پمپ شیر برقی"
                    }
                ]
            },
            {
                subCategoryId: 342,
                name: "زیبایی و تجهیزات آرایشگری",
                subSubCategories: [
                    {
                        subCategoryId: 343,
                        name: "سشوار حرفه ای"
                    },
                    {
                        subCategoryId: 344,
                        name: "اتو مو "
                    },
                    {
                        subCategoryId: 345,
                        name: "بابلیس"
                    },
                    {
                        subCategoryId: 346,
                        name: "دستگاه فر مو"
                    },
                    {
                        subCategoryId: 347,
                        name: "دستگاه کراتینه و پروتئین تراپی"
                    },
                    {
                        subCategoryId: 348,
                        name: "دستگاه اکستنشن مو"
                    },
                    {
                        subCategoryId: 349,
                        name: "دستگاه رنگ و مش"
                    },
                    {
                        subCategoryId: 350,
                        name: "دستگاه هیدروژن تراپی"
                    },
                    {
                        subCategoryId: 351,
                        name: "چراغ و آینه مخصوص میکاپ"
                    },
                    {
                        subCategoryId: 352,
                        name: "دستگاه گریم و ایربراش"
                    },
                    {
                        subCategoryId: 353,
                        name: "کیت کانتورینگ و گریم حرفه ای"
                    },
                    {
                        subCategoryId: 354,
                        name: "دستگاه UV/LED لاک ژل"
                    },
                    {
                        subCategoryId: 355,
                        name: "سوهان برقی ناخن"
                    },
                    {
                        subCategoryId: 356,
                        name: "میز و صندلی مخصوص ناخن کار"
                    },
                    {
                        subCategoryId: 357,
                        name: "ابزار کاشت ناخن"
                    },
                    {
                        subCategoryId: 358,
                        name: "کاتالوگ طرح های ناخن"
                    },
                    {
                        subCategoryId: 359,
                        name: "دستگاه پارافین تراپی"
                    },
                    {
                        subCategoryId: 360,
                        name: "دستگاه وکس (ذوب کننده موم)"
                    },
                    {
                        subCategoryId: 361,
                        name: "تخت اپیلاسیون"
                    },
                    {
                        subCategoryId: 362,
                        name: "پارچه وکس"
                    },
                    {
                        subCategoryId: 363,
                        name: "هیتر و گرم کن موم"
                    },
                    {
                        subCategoryId: 364,
                        name: "دستگاه لیزر خانگی و سالنی"
                    },
                    {
                        subCategoryId: 365,
                        name: "دستگاه بخور صورت"
                    },
                    {
                        subCategoryId: 366,
                        name: "دستگاه هیدرودرم و میکرودرم"
                    },
                    {
                        subCategoryId: 367,
                        name: "دستگاه لیفتینگ و RF"
                    },
                    {
                        subCategoryId: 368,
                        name: "تخت ماساژ"
                    },
                    {
                        subCategoryId: 369,
                        name: "دستگاه میکروپیگمنتیشن"
                    },
                    {
                        subCategoryId: 370,
                        name: "میز و صندلی مخصوص تتوکار"
                    },
                    {
                        subCategoryId: 371,
                        name: "صندلی و آینه آرایشگاهی"
                    }
                ]
            }
        ]
    },
    {
        "categoryId": 7,
        name: "سلامت و پزشکی",
        subCategories: [
            {
                subCategoryId: 372,
                name: "تجهیزات مراقبت از بیمار",
                subSubCategories: [
                    {
                        subCategoryId: 373,
                        name: "ویلچر"
                    },
                    {
                        subCategoryId: 374,
                        name: "واکر"
                    },
                    {
                        subCategoryId: 375,
                        name: "عصا"
                    },
                    {
                        subCategoryId: 376,
                        name: "تخت بیمارستانی"
                    },
                    {
                        subCategoryId: 377,
                        name: "تشک مواج"
                    },
                    {
                        subCategoryId: 378,
                        name: "بالابر بیمار"
                    },
                    {
                        subCategoryId: 379,
                        name: "دستگاه اکسیژن ساز"
                    },
                    {
                        subCategoryId: 380,
                        name: "کپسول اکسیژن"
                    },
                    {
                        subCategoryId: 381,
                        name: "دستگاه کمک تنفسی (CPAP و BiPAP)"
                    },
                    {
                        subCategoryId: 382,
                        name: "مانیتور علائم حیاتی"
                    }
                ]
            },
            {
                subCategoryId: 383,
                name: "تجهیزات مراقبت از مادر و نوزاد",
                subSubCategories: [
                    {
                        subCategoryId: 384,
                        name: "دستگاه زردی نوزاد ( فتوتراپی )"
                    },
                    {
                        subCategoryId: 385,
                        name: "دستگاه شیردوش برقی حرفه ای"
                    },
                    {
                        subCategoryId: 386,
                        name: "دستگاه گرم کن شیشه شیر"
                    },
                    {
                        subCategoryId: 387,
                        name: "دستگاه بیلی روبین متر"
                    }
                ]
            },
            {
                subCategoryId: 388,
                name: "تجهیزات فیزیوتراپی و توان بخشی",
                subSubCategories: [
                    {
                        subCategoryId: 389,
                        name: "دستگاه فیزیوتراپی خانگی"
                    },
                    {
                        subCategoryId: 390,
                        name: "دستگاه الکتروتراپی (TENS)"
                    },
                    {
                        subCategoryId: 391,
                        name: "دستگاه ماساژور حرفه ای"
                    },
                    {
                        subCategoryId: 392,
                        name: "وسایل توان بخشی حرکتی"
                    },
                    {
                        subCategoryId: 393,
                        name: "تردمیل مخصوص فیزیوتراپی"
                    }
                ]
            },
            {
                subCategoryId: 394,
                name: "تجهیزات پزشکی تخصصی",
                subSubCategories: [
                    {
                        subCategoryId: 395,
                        name: "دستگاه نوار قلب (ECG)"
                    },
                    {
                        subCategoryId: 396,
                        name: "دستگاه سونوگرافی پرتابل"
                    },
                    {
                        subCategoryId: 397,
                        name: "فشارسنج دیجیتال "
                    },
                    {
                        subCategoryId: 398,
                        name: "دستگاه تست قند خون "
                    },
                    {
                        subCategoryId: 399,
                        name: "چراغ معاینه پزشکی"
                    },
                    {
                        subCategoryId: 400,
                        name: "اتوسکوپ و افتالموسکوپ  "
                    }
                ]
            },
            {
                subCategoryId: 401,
                name: "تجهیزات آزمایشگاهی و تشخیصی",
                subSubCategories: [
                    {
                        subCategoryId: 402,
                        name: "میکروسکوپ"
                    },
                    {
                        subCategoryId: 403,
                        name: "سانتریفیوژ"
                    },
                    {
                        subCategoryId: 404,
                        name: "هموگلوبین سنج"
                    },
                    {
                        subCategoryId: 405,
                        name: "تب سنج لیزری پزشکی"
                    },
                    {
                        subCategoryId: 406,
                        name: "اسپیرومتر"
                    },
                    {
                        subCategoryId: 407,
                        name: "تست های تشخیصی پرتابل"
                    }
                ]
            },
            {
                subCategoryId: 408,
                name: "تجهیزات پزشکی زیبایی و پوست",
                subSubCategories: [
                    {
                        subCategoryId: 409,
                        name: "دستگاه لیزر پوست"
                    },
                    {
                        subCategoryId: 410,
                        name: "دستگاه میکرودرم ابریژن"
                    },
                    {
                        subCategoryId: 411,
                        name: "دستگاه RF و هایفو"
                    },
                    {
                        subCategoryId: 412,
                        name: "دستگاه مزوتراپی"
                    },
                    {
                        subCategoryId: 413,
                        name: "دستگاه لیفتینگ صورت"
                    }
                ]
            },
            {
                subCategoryId: 414,
                name: "تجهیزات اورژانسی و امداد و نجات",
                subSubCategories: [
                    {
                        subCategoryId: 415,
                        name: "برانکارد"
                    },
                    {
                        subCategoryId: 416,
                        name: "جعبه کمک های اولیه حرفه ای"
                    },
                    {
                        subCategoryId: 417,
                        name: "دفیبریلاتور (AED)"
                    },
                    {
                        subCategoryId: 418,
                        name: "تجهیزات احیا و CPR"
                    },
                    {
                        subCategoryId: 419,
                        name: "کپسول اکسیژن همراه"
                    }
                ]
            }
        ]
    },
    {
        "categoryId": 8,
        name: "وسایل نقلیه صنعتی",
        subCategories: [
            {
                subCategoryId: 420,
                name: "لیفتراک "
            },
            {
                subCategoryId: 421,
                name: "جرثقیل متحرک "
            },
            {
                subCategoryId: 422,
                name: "دامپر و مینی دامپر "
            },
            {
                subCategoryId: 423,
                name: "لودر و مینی لودر "
            },
            {
                subCategoryId: 424,
                name: "بولدوزر "
            },
            {
                subCategoryId: 425,
                name: "گریدر "
            },
            {
                subCategoryId: 426,
                name: "تانکر آب رسان و سوخت رسان"
            },
            {
                subCategoryId: 427,
                name: "تراکتور "
            },
            {
                subCategoryId: 428,
                name: "کمباین "
            },
            {
                subCategoryId: 429,
                name: "تریلر کشاورزی "
            },
            {
                subCategoryId: 430,
                name: "سمپاش خودکششی "
            },
            {
                subCategoryId: 431,
                name: "ماشین نشاکار و بذرکار "
            },
            {
                subCategoryId: 432,
                name: "شیردوش سیار "
            },
            {
                subCategoryId: 433,
                name: "چوب بر جنگلی "
            },
            {
                subCategoryId: 434,
                name: "ماشین آلات مخصوص باغداری "
            }
        ]
    }
]
export default categories;